/**
 * Page manger section providers
 * @module services/pm-section/section-providers
 */

export const SECTION_PROVIDER_PERSONALIZE = 'personalize'
export const SECTION_PROVIDER_PINE = 'pine'
